<template lang="html">
  <div class="a7-pop-up-container">
    <div class="a7-pop-up-list-container" v-for="i in qtdListas" :key="i">
      <a7-pop-up-menu-list :key="i" @selectedOption="selectOption($event, i)" :list="options"
        @emitValues="$emit('input', selectedOptions)" :selectedOptions="selectedOptions.slice(0, i-1)"/>
    </div>
  </div>
</template>

<script>
import A7PopUpMenuList from './A7PopUpMenuList'
export default {
  name: 'a7-pop-up-menu',
  components: {
    A7PopUpMenuList
  },
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedOptions: []
    }
  },
  computed: {
    qtdListas() {
      return this.selectedOptions.length + (this.selectedOptions.length < this.options.length ? 1 : 0)
    }
  },
  methods: {
    selectOption(option, index) {
      if (option == null) {
        this.selectedOptions = [...this.selectedOptions.slice(0, index - 1)]
      }
      else {
        this.selectedOptions = [...this.selectedOptions.slice(0, index - 1), option]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.a7-pop-up-container {
  width: 100%;
  display: flex;
}

.a7-pop-up-menu-item:last-child {
  margin-bottom: 0;
}

.a7-pop-up-list-container {
  position: relative;
  border-right: 1px solid #eee;
  overflow-y: auto;
}

.a7-pop-up-list-container:last-child {
  border-right: none;
}
</style>
